import { OUR_SERVICES } from "../../constants"

export const mapOurServices = (nodes) => {
  return nodes?.map(({category, subCategories}, i) => ({
    ...OUR_SERVICES[i],
    location: `/our-work/${category?.toLowerCase()?.replaceAll(' ', '-')}/${subCategories?.[0]?.toLowerCase()?.replaceAll(' ', '-')}`
  }))
}